import { render, staticRenderFns } from "./legacy-partner-promote.vue?vue&type=template&id=fbf271c6"
import script from "./legacy-partner-promote.vue?vue&type=script&lang=js"
export * from "./legacy-partner-promote.vue?vue&type=script&lang=js"
import style0 from "./legacy-partner-promote.vue?vue&type=style&index=0&id=fbf271c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports